import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { can, homeFor } from '../permissions';

// Route guard: sends anyone not logged in to the login page (returning here afterwards), and anyone
// whose role doesn't allow this page to their own home page. The server enforces the same rules.
const RequireFeature = ({ feature, adminOnly = false, children }) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const location = useLocation();

  if (!userInfo) {
    return <Navigate to={`/login?next=${location.pathname}`} replace />;
  }

  const allowed = adminOnly ? Boolean(userInfo.isAdmin) : can(userInfo, feature);
  if (!allowed) {
    return <Navigate to={homeFor(userInfo)} replace />;
  }

  return children;
};

export default RequireFeature;
